import { useAppSettings } from "./useAppSettings";

export interface PackageConfig {
  price: number;
  credits: number;
  tagline: string;
  label: string;
  /* Testo della colonna centrale su mobile. Opzionali: se mancano, la card
     ricade sui bullet ricavati da `tagline` (comportamento storico). Vivono
     dentro il JSON di `payment_config`, quindi non serve toccare lo schema. */
  mobileTitle?: string;
  mobileDesc?: string;
}

export interface LastChanceConfig {
  price: number;
  credits: number;
}

export interface SubscriptionConfig {
  price: number;
  credits: number;
  period: string; // ISO8601 duration, e.g. "P1M"
}

export interface PaymentConfig {
  packages: {
    A: PackageConfig;
    B: PackageConfig;
    C: PackageConfig;
    D: PackageConfig;
  };
  lastChance: LastChanceConfig;
  subscription: SubscriptionConfig;
}

const DEFAULT_PAYMENT_CONFIG: PaymentConfig = {
  packages: {
    A: { price: 9.99, credits: 500, tagline: "Il modo più semplice per iniziare.", label: "" },
    B: { price: 16.99, credits: 1000, tagline: "Più libertà per le tue conversazioni.", label: "" },
    C: { price: 29.99, credits: 2000, tagline: "Più visibilità. Più connessioni.", label: "Il più scelto" },
    D: { price: 49.99, credits: 4000, tagline: "La massima esperienza senza limiti.", label: "" },
  },
  lastChance: { price: 9.00, credits: 600 },
  subscription: { price: 29.99, credits: 50, period: "P1M" },
};

export function usePaymentConfig() {
  const { getSetting, isLoading } = useAppSettings();

  const raw = getSetting("payment_config", null);
  const config: PaymentConfig = raw
    ? { ...DEFAULT_PAYMENT_CONFIG, ...raw, packages: { ...DEFAULT_PAYMENT_CONFIG.packages, ...raw.packages }, lastChance: { ...DEFAULT_PAYMENT_CONFIG.lastChance, ...raw.lastChance }, subscription: { ...DEFAULT_PAYMENT_CONFIG.subscription, ...raw.subscription } }
    : DEFAULT_PAYMENT_CONFIG;

  return { config, isLoading };
}
